module.exports = __webpack_public_path__ + "static/media/appProfile.ee747da8.png";